/**
 * @title Api Documentation
 * @description Api Documentation
 * @version 1.0
 *
 * Swagger version 2.0
 * Generated at: Thu May 06 2021 09:17:07 GMT+0200 (czas środkowoeuropejski letni)
 */

import { API_URLS } from '../utils/config';
import { request } from '../utils/request';
import prepareQueryParams from 'utils/prepareQueryParams';
import { MgUserJobAuthorizationResponse } from './pricing';

const URL = API_URLS.WORKFLOW;

export interface AbstractResponse<D, L> {
  code: string;
  data: D;
  description: string;
  list: Array<L>;
  message: string;
}

export interface ConsequenceExecRequest {
  entity: string;
  entityId: number;
  procid: number;
  proctaskid: number;
  taskid: number;
}

export interface ConsequenceExecManualRequest {
  entity: string;
  entityid: number;
  procid: number;
  proctaskid: number;
  taskid: number;
  conseqid: number;
  subentity: string;
  subentityid: number;
  objectreference: string;
}

export interface ContractActivationRequest {
  activationMode: string;
  billingDate: string;
  ctduration: number;
  deliveryDate: string;
  deliveryReference: string;
  depositAmount: number;
  entity: string;
  entityId: number;
  finAmount: number;
  generateCommission: boolean;
  generateDisbursment: boolean;
  investAmount: number;
  invoiceDeferredinterest: boolean;
  invoiceDeposit: boolean;
  invoiceFirstrental: boolean;
  invoiceParticipation: boolean;
  invoiceUpfront: boolean;
  listAsset: string;
  participationAmount: number;
  residualValue: number;
  startDate: string;
  taskid: number;
  upfrontAmount: number;
}

export interface DataProcTaskCheckResponse {
  ccode: string;
  checkcode: string;
  checkid: number;
  checkstatus: string;
  checkstatusdate: string;
  checktype: string;
  doccode: string;
  docid: number;
  holderid: number;
  proccodetagret: string;
  procid: number;
  proctaskcheckid: number;
  proctaskid: number;
  receiverid: number;
  receiverroleprofile: string;
  receivertype: string;
  senderid: number;
  targetdate: string;
  taskid: number;
  taskidtarget: number;
  useridcreation: number;
  useridstatus: number;
}
export interface ParSynthesisResponse {
  synid: number;
  syncode: string;
  synlabel: string;
  synvalue: string;
  synvaluelabel: string;
  syntargetobject: string;
  syntargetobjectid: number;
  syndisplay: string;
  syncolor: string;
  synfontsize: string;
}

export interface DataProcTaskConseqResponse {
  checkid: number;
  conseqid: number;
  conseqstatus: string;
  conseqstatusdate: string;
  conseqtype: string;
  holderid: number;
  notifid: number;
  notifmessage: string;
  proccodetagret: string;
  procid: number;
  proctaskcheckid: number;
  proctaskid: number;
  receiverid: number;
  receiverroleprofile: string;
  receivertype: string;
  senderid: number;
  targetdate: string;
  taskid: number;
  taskidtarget: number;
}

export interface ExecParametersRequest {
  comment: string;
  entity: string;
  entityId: number;
  externalreference: string;
  gridid: number;
  jobid: number;
  pardate: string;
  parvalue: string;
  phase: string;
  stage: string;
  status: string;
  taskid: number;
  tpid: number;
  tprole: string;
  tpreference?: string;
  tpname?: string;
  currcode?: string;
  tpclass?: string;
  flagaction?: boolean;
  targetuserid?: number;
  objectreference?: string;
  requestedamount?: number;
}

export interface ParProcTaskCheckRequest {
  applicationrule: string;
  ccode: string;
  checkcode: string;
  checkid: number;
  checklabel: string;
  checkorder: number;
  checkrequesttype: string;
  checktype: string;
  doccode: string;
  notifdecisionreceiverid: number;
  notifdecisionreceiverroleprofile: string;
  notifdecisionreceivertype: string;
  notifdecisionstatus: boolean;
  notifoverridereceiverid: number;
  notifoverridereceiverroleprofile: string;
  notifoverridereceivertype: string;
  notifoverridestatus: boolean;
  proccode: string;
  proccodetarget: string;
  receiverid: number;
  receiverroleprofile: string;
  receivertype: string;
  taskid: number;
  taskidtarget: number;
}

export interface ParProcTaskCheckResponse {
  applicationrule: string;
  ccode: string;
  ccodelabel: string;
  checkcode: string;
  checkid: number;
  checklabel: string;
  checkorder: number;
  checkrequesttype: string;
  checkrequesttypelabel: string;
  checktype: string;
  checktypelabel: string;
  doccode: string;
  doccodelabel: string;
  notifdecisionreceiverid: number;
  notifdecisionreceivername: string;
  notifdecisionreceiverroleprofile: string;
  notifdecisionreceiverroleprofilelabel: string;
  notifdecisionreceivertype: string;
  notifdecisionreceivertypelabel: string;
  notifdecisionstatus: boolean;
  notifoverridereceiverid: number;
  notifoverridereceivername: string;
  notifoverridereceiverroleprofile: string;
  notifoverridereceiverroleprofilelabel: string;
  notifoverridereceivertype: string;
  notifoverridereceivertypelabel: string;
  notifoverridestatus: boolean;
  proccode: string;
  proccodetarget: string;
  proccodetargetlabel: string;
  receiverid: number;
  receivername: string;
  receiverroleprofile: string;
  receiverroleprofilelabel: string;
  receivertype: string;
  receivertypelabel: string;
  taskid: number;
  taskidtarget: number;
  taskidtargetlabel: number;
}

export interface ParProcTaskConseqRequest {
  applicationrule: string;
  conseqcode: string;
  conseqid: number;
  conseqlabel: string;
  conseqorder: number;
  conseqtype: string;
  proccode: string;
  proccodetarget: string;
  receiverid: number;
  receiverroleprofile: string;
  receivertype: string;
  taskid: number;
  taskidtarget: number;
  targetphase: string;
  targetstatus: string;
  triggermode: string;
  emailto: string;
  emailcc: string;
}

export interface ParProcTaskConseqResponse {
  applicationrule: string;
  conseqcode: string;
  conseqid: number;
  conseqlabel: string;
  conseqorder: number;
  conseqtype: string;
  conseqtypelabel: string;
  proccode: string;
  proccodetarget: string;
  proccodetargetlabel: string;
  receiverid: number;
  receivername: string;
  receiverroleprofile: string;
  receiverroleprofilelabel: string;
  receivertype: string;
  receivertypelabel: string;
  taskid: number;
  taskidtarget: number;
  taskidtargetlabel: string;
  targetphase: string;
  targetstatus: string;
  triggermode: string;
  emailto: string;
  emailcc: string;
  entitytarget: string;
  entityproctarget: string;
  entitytaskidtarget: number;
  executiondelay: number;
}

export interface ParProcTaskRequest {
  applicationrule: string;
  enddate: string;
  flagbegin: boolean;
  funcode: string;
  proccode: string;
  receiverid: number;
  receiverroleprofile: string;
  receivertype: string;
  startdate: string;
  taskid: number;
  tasklabel: string;
  taskorder: number;
  tasksilent: boolean;
  taskstatus: string;
  tasktriggermode: string;
  tasktype: string;
  subentity: string;
}

export interface ParProcTaskResponse {
  applicationrule: string;
  enddate: string;
  flagbegin: boolean;
  funcode: string;
  funlabel: string;
  proccode: string;
  procmodule: string;
  receiverid: number;
  receivername: string;
  receiverroleprofile: string;
  receiverroleprofilelabel: string;
  receivertype: string;
  receivertypelabel: string;
  startdate: string;
  taskid: number;
  tasklabel: string;
  taskorder: number;
  tasksilent: boolean;
  taskstatus: string;
  taskstatuslabel: string;
  tasktriggermode: string;
  tasktrigger: string;
  tasktriggermodelabel: string;
  tasktype: string;
  tasktypelabel: string;
  subentity: string;
}

export interface ParProcTaskStepRequest {
  applicationrule: string;
  funcode: string;
  proccode: string;
  stepid: number;
  steplabel: string;
  steporder: number;
  stepsilent: boolean;
  steptriggermode: string;
  steptype: string;
  taskid: number;
}

export interface FinModSimulParamStep {
  ctesid: number;
  ctrid: number;
  ctesorder: number;
  ctesduration: number;
  ctesperiodicity: string;
  ctesperiodicityunit: string;
  ctesrentalcoef: number;
  ctesoutstandingamount: number;
  ctesrentalamount: number;
  ctesamortizedcoef: number;
}
export interface FinModSimulParams {
  grossamount: number;
  newvalue: string;
  oldvalue: string;
  paramid: number;
  parcode: string;
  partype: string;
  taxamount: number;
  taxcode: string;
  taxrate: number;
  finModSimulParamSteps: Array<FinModSimulParamStep>;
}
export interface FinModElementReschedulingRequest {
  ctebilligdate: string;
  ctecalculationtype: string;
  cteduration: number;
  ctefirstpayment: number;
  cteid: number;
  cteinstallmentamount: number;
  ctenominalrate: number;
  cteoutstandingamount: number;
  cteperiodicity: string;
  cterentalamount: number;
  ctervamount: number;
  cteunit: string;
  finModSimulParams: Array<FinModSimulParams>;
  flagStop: boolean;
}
export interface inFinModificationRequest {
  comment: string;
  ctrid: number;
  effectDate: string;
  entity: string;
  entityId: number;
  feesAmount: number;
  feesFormula: string;
  finModElementReschedulingRequest: Array<FinModElementReschedulingRequest>;
  mode: string;
  modid: number;
  subentity: string;
  subentityId: number;
  taskid: number;
}
export interface ParProcTaskStepResponse {
  applicationrule: string;
  funcode: string;
  funlabel: string;
  proccode: string;
  stepid: number;
  steplabel: string;
  steporder: number;
  stepsilent: boolean;
  steptriggermode: string;
  steptriggermodelabel: string;
  steptype: string;
  steptypelabel: string;
  taskid: number;
}

export interface ParProcedureRequest {
  applicationrule: string;
  enddate: string;
  parprocid: number;
  proccode: string;
  proclabel: string;
  procmodule: string;
  procstatus: string;
  proctriggermode: string;
  requiresid: boolean;
  startdate: string;
}

export interface ParProcedureResponse {
  applicationrule: string;
  enddate: string;
  parprocid: number;
  proccode: string;
  proclabel: string;
  procmodule: string;
  procmodulelabel: string;
  procstatus: string;
  procstatuslabel: string;
  proctriggermode: string;
  proctriggermodelabel: string;
  requiresid: boolean;
  startdate: string;
}

export interface ProcInitHomeResponse {
  funcode: string;
  id: number;
  lancode: string;
  mgid: number;
  mgname: string;
  proccode: string;
  procmodule: string;
  taskid: number;
  tasklabel: string;
  tasktriggermode: string;
  tasktype: string;
  userid: number;
}

export interface ProcInitWizard {
  funcode: string;
  id: number;
  lancode: string;
  proccode: string;
  procmodule: string;
  procrule: string;
  requiresid: boolean;
  taskid: number;
  tasklabel: string;
  taskrule: string;
  tasktriggermode: string;
  tasktype: string;
}

export interface ProcTaskCheckRequest {
  ccode: string;
  checkcode: string;
  checkid: number;
  checkorder: number;
  checkrequesttype: string;
  checkstatus: string;
  checktype: string;
  doccode: string;
  entityid: number;
  proccode: string;
  proccodetarget: string;
  procid: number;
  procmodule: string;
  proctaskcheckid: number;
  proctaskid: number;
  receiverid: number;
  receiverroleprofile: string;
  receivertype: string;
  taskid: number;
  taskidtarget: number;
  minvalue: number;
  maxvalue: number;
  defaultvalue: number;
  requestvalue: number;
  subobject: string;
  subobjectid: number;
  attcode: string;
  priid: number;
  offerid: number;
  authid: number;
  objectreference: string;
}

export interface ProcTaskInit {
  funcode: string;
  id: number;
  lancode: string;
  proccode: string;
  procmodule: string;
  procrule: string;
  serviceurl: string;
  taskid: number;
  tasklabel: string;
  taskrule: string;
  tasktriggermode: string;
  tasktype: string;
  subentity: string;
  subentityid: number;
}

export interface ProcTaskListResponse {
  taskid: number;
  tasklabel: string;
}

export interface ProcedureListResponse {
  proccode: string;
  proclabel: string;
}

export interface TaskCheckEntityResponse {
  ccode: string;
  checkRequestTypeLabel: string;
  checkStatus: string;
  checkcode: string;
  checkid: number;
  checklabel: string;
  checkorder: number;
  checkrequesttype: string;
  checktype: string;
  clabel: string;
  cmessage: string;
  controlCheck: boolean;
  docPath: string;
  doccode: string;
  doclabel: string;
  entityid: number;
  id: number;
  lancode: string;
  procID: number;
  proccode: string;
  proccodetarget: string;
  procmodule: string;
  proctaskID: number;
  proctaskcheckID: number;
  receiverRoleProfile: string;
  receiverRoleProfileLabel: string;
  receiverTypeLabel: string;
  receiverid: number;
  receivertype: string;
  statusLabel: string;
  taskid: number;
  taskidtarget: number;
  userIdStatus: number;
  userNameAction: string;
  userNameStatus: string;
  checkactionmessage: string;
  checkaction: string;
  checkmessage: string;
  minvalue: number;
  maxvalue: number;
  defaultvalue: number;
  requestvalue: number;
  subobject: string;
  subobjectid: number;
  attcode: string;
  priid: number;
  offerid: number;
  authid: number;
  authList: Array<MgUserJobAuthorizationResponse>;
  notifoverridereceiverroleprofile: any;
  notifoverridereceivertype: any;
}

export interface TaskConseqEntityResponse {
  applicationrule: string;
  conseqcode: string;
  conseqid: number;
  conseqlabel: string;
  conseqorder: number;
  conseqstatus: string;
  conseqstatuslabel: string;
  conseqtype: string;
  conseqtypelabel: string;
  entity: string;
  entityid: number;
  id: number;
  lancode: string;
  procID: number;
  proccode: string;
  proccodetarget: string;
  proctargetlabel: string;
  proctaskID: number;
  proctaskconseqID: number;
  receiverRoleProfileLabel: string;
  receiverTypeLabel: string;
  receiverid: number;
  receiverroleprofile: string;
  receivertype: string;
  receivername: string;
  taskid: number;
  taskidtarget: number;
  tasktargetlabel: string;
  userNameAction: string;
  targetphase: string;
  targetstatus: string;
  subentity: string;
  subentityid: number;
  notifid: number;
  emailto: string;
  emailcc: string;

  printid: number;
  emailtotarget: string;
  emailcctarget: string;
}

export interface TaskStepEntityResponse {
  applicationrule: string;
  funcode: string;
  id: number;
  lancode: string;
  proccode: string;
  procmodule: string;
  stepid: number;
  steplabel: string;
  steporder: number;
  steptriggermode: string;
  taskfuncode: string;
  taskid: number;
}

export interface TaskStepHomeResponse {
  funcode: string;
  id: number;
  lancode: string;
  proccode: string;
  stepid: number;
  steplabel: string;
  steporder: number;
  steptriggermode: string;
  taskid: number;
  userid: number;
}

export interface ViewProcTaskCheckResponse {
  checkstatus: string;
  checkstatusdate: string;
  cmessage: string;
  holderid: number;
  holdername: string;
  id: number;
  lancode: string;
  modulename: string;
  objectid: number;
  objectreference: string;
  procmodule: string;
  proctaskcheckid: number;
  proctaskid: number;
  receiverid: number;
  receivername: string;
  receiverroleprofile: string;
  receiverroleprofilelabel: string;
  receivertype: string;
  receivertypelabel: string;
  senderid: number;
  sendername: string;
  taskid: number;
  userid: number;
  actioncheck: string;
  checkstatuslabel: string;
  useridstatus: number;
  minvalue: number;
  maxvalue: number;
  defaultvalue: number;
  requestvalue: number;
  usernamestatus: string;
}

export interface ViewProcTaskFollowUpResponse {
  funcode: string;
  holderid: number;
  holdername: string;
  id: number;
  modtype: string;
  modulename: string;
  objectid: number;
  objectreference: string;
  procTaskCheck: Array<ViewProcTaskCheckResponse>;
  procTaskConseq: Array<ViewProcTaskNotifResponse>;
  procTaskChild: Array<ViewProcTaskFollowUpResponse>;
  proccode: string;
  procid: number;
  procmodule: string;
  proctaskid: number;
  receiverid: number;
  receivername: string;
  receiverroleprofile: string;
  receiverroleprofilelabel: string;
  receivertype: string;
  receivertypelabel: string;
  senderid: number;
  sendername: string;
  startdate: string;
  taskid: number;
  tasklabel: string;
  taskstatus: string;
  taskstatusdate: string;
  taskstatuslabel: string;
  taskcomment: string;
  tasklabel2: string;
  taskdate: string;
}

export interface ViewProcTaskNotifResponse {
  checkid: number;
  conseqcode: string;
  conseqid: number;
  conseqlabel: string;
  conseqstatuslabel: string;
  conseqtype: string;
  conseqtypelabel: string;
  emailcctarget: string;
  emailtotarget: string;
  entity: string;
  entityid: number;
  entitytarget: string;
  cmessage: string;
  conseqstatus: string;
  conseqstatusdate: string;
  holderid: number;
  holdername: string;
  id: number;
  lancode: string;
  modulename: string;
  notifid: number;
  notifmessage: string;
  objectid: number;
  objectreference: string;
  printid: number;
  proccodetarget: string;
  proccodetargetlabel: string;
  procmodule: string;
  proctaskcheckid: number;
  proctaskid: number;
  receiverid: number;
  receivername: string;
  receiverroleprofile: string;
  receiverroleprofilelabel: string;
  receivertype: string;
  receivertypelabel: string;
  senderid: number;
  sendername: string;
  subentity: string;
  subentityid: number;
  taskid: number;
  taskidtarget: number;
  taskidtargetlabel: string;
  userid: number;
}

export interface ViewProcTaskResponse {
  funcode: string;
  holderid: number;
  holdername: string;
  id: number;
  modulename: string;
  objectid: number;
  objectreference: string;
  proccode: string;
  proccodelabel: string;
  procid: number;
  procmodule: string;
  proctaskid: number;
  receiverid: number;
  receivername: string;
  receiverroleprofile: string;
  receiverroleprofilelabel: string;
  receivertype: string;
  receivertypelabel: string;
  senderid: number;
  sendername: string;
  startdate: string;
  taskid: number;
  tasklabel: string;
  taskstatus: string;
  taskstatusdate: string;
  taskstatuslabel: string;
  serviceurl: string;
}

export interface WFengineResponse {
  entity: string;
  entityid: number;
  message: string;
  proccode: string;
  procid: number;
  proctaskid: number;
  success: boolean;
  taskid: number;
  subentity: string;
  subentityid: number;
}

export interface inDecisionRequest {
  assetnote: string;
  assetreserve: boolean;
  coborrowernote: string;
  coborrowerreserve: boolean;
  deccode: string;
  deccomment: string;
  decdate: string;
  declevel: string;
  dectype: string;
  deposit: number;
  depositapproved: number;
  depositreserve: boolean;
  duration: number;
  durationapproved: number;
  durationreserve: boolean;
  entity: string;
  entityId: number;
  finamountapproved: number;
  finamountreserve: boolean;
  firstpayment: number;
  firstpaymentapproved: number;
  firstpaymentreserve: boolean;
  guarantornote: string;
  guarantorreserve: boolean;
  insurancenote: string;
  insurancereserve: boolean;
  jobid: number;
  rate: number;
  rateapproved: number;
  ratereserve: boolean;
  reqfinamount: number;
  residualvalue: number;
  residualvalueapproved: number;
  residualvaluereserve: boolean;
  taskid: number;
  warrantynote: string;
  warrantyreserve: boolean;
}

export interface inChangeDurationRequest {
  taskid: number;
  entity: string;
  entityId: number;
  subentity: number;
  subentityId: number;
  effectDate: string;
  newDuration: number;
  invoiceFees: boolean;
  feesFormula: string;
  feesAmount: number;
  mode: string; //CALCUL, SIMUL, REAL
  modid: number;
  comment: string;
}
export interface inGuarantyRequest {
  currcode: string;
  entity: string;
  entityId: number;
  guaradrcity: string;
  guaradrregion: string;
  guaradrstreet1: string;
  guaradrstreet2: string;
  guaradrzipcode: string;
  guaramount: number;
  guardescription: string;
  guarexternalref: string;
  guarrank: string;
  guarreceptiondate: string;
  guarsignaturedate: string;
  guartype: string;
  guarusageamount: number;
  jobid: number;
  taskid: number;
  tpidbeneficiary: number;
  tpidguarantor: number;
}

export interface inPurchaseOrderRequest {
  deliveryadrcity: string;
  deliveryadrregion: string;
  deliveryadrstreet1: string;
  deliveryadrstreet2: string;
  deliveryadrzipcode: string;
  entity: string;
  entityId: number;
  groupingMode: string;
  jobid: number;
  poexpecteddeliverydate: string;
  popaymentdelay: string;
  popaymentmode: string;
  taskid: number;
}
export interface ParSynResponse {
  applicationrule: string;
  objecttype: string;
  parcode: string;
  sqlfunction: string;
  syncode: string;
  syncolor: string;
  syndataorigin: string;
  syndisplay: string;
  synfontsize: string;
  synid: number;
  synlabel: string;
  synorder: number;
  syntargetobject: string;
  tabcolumn: string;
  tabcolumntarget: string;
  tabkey: string;
  tabtable: string;
  tabwhere: string;
  tabwheretarget: string;
}
export interface GetParSynthesisByCriteriaParams {
  applicationrule: string;
  objecttype: string;
  parcode: string;
  syncode: string;
  syndataorigin: string;
  syndisplay: string;
  syntargetobject: string;
}

export interface EntityFollowUpResponse {
  action: string;
  actiondate: string;
  actionlabel: string;
  entity: string;
  entitylabel: string;
  entityid: number;
  entityreference: string;
  id: number;
  proctaskid: number;
  status: string;
  statuslabel: string;
  taskid: number;
  tasklabel: string;
  userid: number;
  username: string;
}

export interface ScheduleTopicNotInvoicedResponse {
  assetid: number;
  ciid: number;
  ctdescription: string;
  ctesid: number;
  ctrid: number;
  ctsactuarialrate: number;
  ctsamortizedamount: number;
  ctsbasisamount: number;
  ctsbasisrate: number;
  ctscategory: string;
  ctscategorylabel: string;
  ctsdepositbasis: number;
  ctsdepositinterest: number;
  ctsdepositrate: number;
  ctsduedate: string;
  ctsenddate: string;
  ctsid: number;
  ctsinterestamount: number;
  ctsorder: number;
  ctsoutstandingamount: number;
  ctsperiodicity: string;
  ctsrentalamount: number;
  ctsstartamount: number;
  ctsstartdate: string;
  ctsstatus: string;
  ctsterm: string;
  ctstype: string;
  ctstypelabel: string;
  entityreference: string;
  taxcode: string;
  tpid: number;
  tpname: string;
  tpreference: string;
  currcode: string;
}

export interface Proctaskconseq {
  checkid: number;
  conseqid: number;
  conseqstatus: string;
  conseqstatusdate: string;
  conseqtype: string;
  emailcc: string;
  emailto: string;
  holderid: number;
  notifid: number;
  notifmessage: string;
  printid: number;
  procid: number;
  proctaskcheckid: number;
  proctaskid: number;
  receiverid: number;
  receiverroleprofile: string;
  receivertype: string;
  senderid: number;
  targetdate: string;
  taskid: number;
  taskidtarget: number;
}

export interface FinModRestoreRequestWf {
  comment: string;
  entity: string;
  entityId: number;
  event: string;
  modid: number;
  objectreference: string;
  reason: string;
  subentity: string;
  subentityid: number;
  taskid: number;
}
export interface ProctaskConseqListResponse {
  checkid: number;
  conseqcode: string;
  conseqid: number;
  conseqstatus: string;
  conseqstatusdate: string;
  conseqtype: string;
  emailcc: string;
  emailto: string;
  holderid: number;
  id: number;
  notifid: number;
  notifmessage: string;
  objectid: number;
  objectreference: string;
  printid: number;
  proccodetagret: string;
  procid: number;
  procmodule: string;
  procmodulelabel: string;
  proctaskcheckid: number;
  proctaskid: number;
  receiverid: number;
  receiverroleprofile: string;
  receivertype: string;
  senderid: number;
  targetdate: string;
  taskid: number;
  taskidtarget: number;
}

export interface ParProcTaskMgRequest {
  id: number;
  mgid: number;
  taskid: number;
}

export interface ParProcTaskMgResponse {
  id: number;
  mgid: number;
  mgname: string;
  taskid: number;
  tasklabel: string;
}

export interface ParProcTaskProductRequest {
  id: number;
  prcode: string;
  taskid: number;
}

export interface ParProcTaskProductResponse {
  id: number;
  prcode: string;
  prcodelabel: string;
  taskid: number;
  tasklabel: string;
}

export interface InTpAuthorizationUseRequest {
  amountToUse: number;
  authdetailid: number;
  authid: number;
  beneficiaryname: string;
  beneficiaryreference: string;
  calculationtype: string;
  duration: number;
  endDate: string;
  entity: string;
  entityId: number;
  nominalrate: number;
  objectreference: string;
  offerid: number;
  ofrid: number;
  ofrtype: string;
  periodicity: string;
  prcode: string;
  rateformula: string;
  rateref: number;
  ratespread: number;
  ratetype: string;
  startDate: string;
  subentity: string;
  subentityId: number;
  taskid: number;
  tpidbeneficiairy: number;
  usecomment: string;
}


/**
 * @tags Workflow Controller
 * @summary GetParSynthesisByCriteria
 */
export function GetParSynthesisByCriteria(
  params: GetParSynthesisByCriteriaParams
) {
  return request.get<AbstractResponse<object, ParSynResponse>>(
    `${URL}/api/Synthesis` +
      prepareQueryParams({
        applicationrule: params.applicationrule,
        objecttype: params.objecttype,
        parcode: params.parcode,
        syncode: params.syncode,
        syndataorigin: params.syndataorigin,
        syndisplay: params.syndisplay,
        syntargetobject: params.syntargetobject,
      } as any)
  );
}

export interface AddParSynthesisParams {
  request: ParSynResponse;
}

/**
 * @tags Workflow Controller
 * @summary AddParSynthesis
 */
export function AddParSynthesis(params: AddParSynthesisParams) {
  return request.post<AbstractResponse<ParSynResponse, object>>(
    `${URL}/api/Synthesis`,
    params.request
  );
}

export interface GetParSynthesisByIDParams {
  synid: number;
}

/**
 * @tags Workflow Controller
 * @summary GetParSynthesisByID
 */
export function GetParSynthesisByID(params: GetParSynthesisByIDParams) {
  return request.get<AbstractResponse<ParSynResponse, object>>(
    `${URL}/api/Synthesis/${params.synid}`
  );
}

export interface UpdateParSynthesisParams {
  request: ParSynResponse;
  synid: number;
}

/**
 * @tags Workflow Controller
 * @summary UpdateParSynthesis
 */
export function UpdateParSynthesis(params: UpdateParSynthesisParams) {
  return request.put<AbstractResponse<ParSynResponse, object>>(
    `${URL}/api/Synthesis/${params.synid}`,
    params.request
  );
}

export interface RemoveParSynthesisParams {
  synid: number;
}

/**
 * @tags Workflow Controller
 * @summary RemoveParSynthesis
 */
export function RemoveParSynthesis(params: RemoveParSynthesisParams) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/api/Synthesis/${params.synid}`
  );
}

export interface ActivateContractOnAssetDeliveryParams {
  Authorization: string;
  ctActivationRequest: ContractActivationRequest;
}

/**
 * @tags Workflow Controller
 * @summary activateContractOnAssetDelivery
 */
export function activateContractOnAssetDelivery(
  params: ActivateContractOnAssetDeliveryParams
) {
  return request.post<WFengineResponse>(
    `${URL}/api/Exec/ActivateContractOnAssetDelivery`,
    params.ctActivationRequest
  );
}

export interface AddGuarantyParams {
  Authorization: string;
  guarantyRequest: inGuarantyRequest;
}

/**
 * @tags Workflow Controller
 * @summary addGuaranty
 */
export function addGuaranty(params: AddGuarantyParams) {
  return request.post<WFengineResponse>(
    `${URL}/api/Exec/AddGuaranty`,
    params.guarantyRequest
  );
}

export interface CreateScoringFileParams {
  Authorization: string;
  requestParam: ExecParametersRequest;
}

/**
 * @tags Workflow Controller
 * @summary createScoringFile
 */
export function createScoringFile(params: CreateScoringFileParams) {
  return request.post<WFengineResponse>(
    `${URL}/api/Exec/CreateScoringFile`,
    params.requestParam
  );
}

export interface GenerateCreditNoteCIParams {
  Authorization: string;
  requestParam: ExecParametersRequest;
}

/**
 * @tags Workflow Controller
 * @summary generateCreditNoteCI
 */
export function generateCreditNoteCI(params: GenerateCreditNoteCIParams) {
  return request.post<WFengineResponse>(
    `${URL}/api/Exec/CreditNoteCI`,
    params.requestParam
  );
}

export interface GenerateCreditNoteSIParams {
  Authorization: string;
  requestParam: ExecParametersRequest;
}

/**
 * @tags Workflow Controller
 * @summary generateCreditNoteSI
 */
export function generateCreditNoteSI(params: GenerateCreditNoteSIParams) {
  return request.post<WFengineResponse>(
    `${URL}/api/Exec/CreditNoteSI`,
    params.requestParam
  );
}

export interface GenerateContractReferenceParams {
  Authorization: string;
  requestParam: ExecParametersRequest;
}

/**
 * @tags Workflow Controller
 * @summary generateContractReference
 */
export function generateContractReference(
  params: GenerateContractReferenceParams
) {
  return request.post<WFengineResponse>(
    `${URL}/api/Exec/GenerateReferenceContract`,
    params.requestParam
  );
}

export interface InsertDecisionParams {
  Authorization: string;
  decRequest: inDecisionRequest;
}

/**
 * @tags Workflow Controller
 * @summary insertDecision
 */
export function insertDecision(params: InsertDecisionParams) {
  return request.post<WFengineResponse>(
    `${URL}/api/Exec/InsertDecision`,
    params.decRequest
  );
}

export interface GenerateCIPaymentParams {
  Authorization: string;
  requestParam: ExecParametersRequest;
}

/**
 * @tags Workflow Controller
 * @summary generateCIPayment
 */
export function generateCIPayment(params: GenerateCIPaymentParams) {
  return request.post<WFengineResponse>(
    `${URL}/api/Exec/PaymentCI`,
    params.requestParam
  );
}
export interface getSynthesisParams {
  objecttype: string;
  objectid: number;
}

/**
 * @tags Workflow Controller
 * @summary generateCIPayment
 */
export function getSynthesis(params: getSynthesisParams) {
  return request.get<AbstractResponse<object, ParSynthesisResponse>>(
    `${URL}/api/objectSynthesis` +
      prepareQueryParams({
        objecttype: params.objecttype,
        objectid: params.objectid,
      } as any)
  );
}

export interface GenerateSIPaymentParams {
  Authorization: string;
  requestParam: ExecParametersRequest;
}

/**
 * @tags Workflow Controller
 * @summary generateSIPayment
 */
export function generateSIPayment(params: GenerateSIPaymentParams) {
  return request.post<WFengineResponse>(
    `${URL}/api/Exec/PaymentSI`,
    params.requestParam
  );
}

export interface CreatePropAssetOrderParams {
  Authorization: string;
  purchaseOrder: inPurchaseOrderRequest;
}

/**
 * @tags Workflow Controller
 * @summary createPropAssetOrder
 */
export function createPropAssetOrder(params: CreatePropAssetOrderParams) {
  return request.post<WFengineResponse>(
    `${URL}/api/Exec/PropAssetOrdering`,
    params.purchaseOrder
  );
}

export interface RejectPaymentParams {
  Authorization: string;
  requestParam: ExecParametersRequest;
}

/**
 * @tags Workflow Controller
 * @summary rejectPayment
 */
export function rejectPayment(params: RejectPaymentParams) {
  //
  // return request.post<WFengineResponse>(
  //   `${URL}/payment/${params.requestParam}/reject`
  // );
}

export interface UpdateStatusCIParams {
  Authorization: string;
  requestParam: ExecParametersRequest;
}

/**
 * @tags Workflow Controller
 * @summary updateStatusCI
 */
export function updateStatusCI(params: UpdateStatusCIParams) {
  return request.post<WFengineResponse>(
    `${URL}/api/Exec/UpdateStatusCI`,
    params.requestParam
  );
}

export interface UpdateStatusContractParams {
  Authorization: string;
  requestParam: ExecParametersRequest;
}

/**
 * @tags Workflow Controller
 * @summary updateStatusContract
 */
export function updateStatusContract(params: UpdateStatusContractParams) {
  return request.post<WFengineResponse>(
    `${URL}/api/Exec/UpdateStatusContract`,
    params.requestParam
  );
}

export interface UpdateStatusDocumentParams {
  Authorization: string;
  requestParam: ExecParametersRequest;
}

/**
 * @tags Workflow Controller
 * @summary updateStatusDocument
 */
export function updateStatusDocument(params: UpdateStatusDocumentParams) {
  return request.post<WFengineResponse>(
    `${URL}/api/Exec/UpdateStatusDocument`,
    params.requestParam
  );
}

export interface UpdateStatusPaymentParams {
  Authorization: string;
  requestParam: ExecParametersRequest;
}

/**
 * @tags Workflow Controller
 * @summary updateStatusPayment
 */
export function updateStatusPayment(params: UpdateStatusPaymentParams) {
  return request.post<WFengineResponse>(
    `${URL}/api/Exec/UpdateStatusPayment`,
    params.requestParam
  );
}

export interface UpdateStatusPropPurchaseOrderParams {
  Authorization: string;
  requestParam: ExecParametersRequest;
}

/**
 * @tags Workflow Controller
 * @summary updateStatusPropPurchaseOrder
 */
export function updateStatusPropPurchaseOrder(
  params: UpdateStatusPropPurchaseOrderParams
) {
  return request.post<WFengineResponse>(
    `${URL}/api/Exec/UpdateStatusPropPurchaseOrder`,
    params.requestParam
  );
}

export interface UpdateStatusSIParams {
  Authorization: string;
  requestParam: ExecParametersRequest;
}

/**
 * @tags Workflow Controller
 * @summary updateStatusSI
 */
export function updateStatusSI(params: UpdateStatusSIParams) {
  return request.post<WFengineResponse>(
    `${URL}/api/Exec/UpdateStatusSI`,
    params.requestParam
  );
}

export interface UpdateStatusScoringParams {
  Authorization: string;
  requestParam: ExecParametersRequest;
}

/**
 * @tags Workflow Controller
 * @summary updateStatusScoring
 */
export function updateStatusScoring(params: UpdateStatusScoringParams) {
  return request.post<WFengineResponse>(
    `${URL}/api/Exec/UpdateStatusScoring`,
    params.requestParam
  );
}

/**
 * @tags Workflow Controller
 * @summary GetListProcTaskCheck
 */
export function GetListProcTaskCheck() {
  return request.get<AbstractResponse<object, ViewProcTaskCheckResponse>>(
    `${URL}/api/myChecklist`
  );
}

/**
 * @tags Workflow Controller
 * @summary GetListProcTaskNotif
 */
export function GetListProcTaskNotif() {
  return request.get<AbstractResponse<object, ViewProcTaskNotifResponse>>(
    `${URL}/api/myNotiflist`
  );
}

/**
 * @tags Workflow Controller
 * @summary getAllProcInitHome
 */
export function getAllProcInitHome() {
  return request.get<AbstractResponse<object, ProcInitHomeResponse>>(
    `${URL}/api/myProcedures/all`
  );
}

/**
 * @tags Workflow Controller
 * @summary getProcInitHome
 */
export function getProcInitHome() {
  return request.get<AbstractResponse<object, ProcInitHomeResponse>>(
    `${URL}/api/myProcedures/home`
  );
}

export interface GetMyTasksParams {
  entity?: string;
  entityid?: number;
  proccode?: string;
  taskid?: number;
  taskstatus?: string;
  flagholder?: boolean;
  flagsender?: boolean;
  flagreceiver?: boolean;
}

/**
 * @tags Workflow Controller
 * @summary GetMyTasks
 */
export function GetMyTasks(params: GetMyTasksParams) {
  return request.get<AbstractResponse<object, ViewProcTaskResponse>>(
    `${URL}/api/myTasks` +
      prepareQueryParams({
        entity: params.entity,
        entityid: params.entityid,
        proccode: params.proccode,
        taskid: params.taskid,
        taskstatus: params.taskstatus,
        flagholder: params.flagholder,
        flagreceiver: params.flagreceiver,
        flagsender: params.flagsender,
      } as any)
  );
}

export interface GetProcedureListByEntityParams {
  entity: string;
}

/**
 * @tags Workflow Controller
 * @summary getProcedureListByEntity
 */
export function getProcedureListByEntity(
  params: GetProcedureListByEntityParams
) {
  return request.get<AbstractResponse<object, ProcedureListResponse>>(
    `${URL}/api/procedureList` +
      prepareQueryParams({ entity: params.entity } as any)
  );
}

export interface GetProcTaskInitParams {
  entity: string;
  entityid: number;
  funcode: string;
  action: string;
  prcode: string;
}

/**
 * @tags Workflow Controller
 * @summary getProcTaskInit
 */
export function getProcTaskInit(params: GetProcTaskInitParams) {
  return request.get<AbstractResponse<object, ProcTaskInit>>(
    `${URL}/api/procedures/tasks/actions` +
      prepareQueryParams({
        entity: params.entity,
        entityid: params.entityid,
        funcode: params.funcode,
        action: params.action,
        prcode: params.prcode,
      } as any)
  );
}

/**
 * @tags Workflow Controller
 * @summary getProcInitWizardList
 */
export function getProcInitWizardList() {
  return request.get<AbstractResponse<object, ProcInitWizard>>(
    `${URL}/api/procedures/wizards`
  );
}

export interface GetEntityProcessFollowupParams {
  entity: string;
  entityid: number;
}

/**
 * @tags Workflow Controller
 * @summary getEntityProcessFollowup
 */
export function getEntityProcessFollowup(
  params: GetEntityProcessFollowupParams
) {
  return request.get<AbstractResponse<object, ViewProcTaskFollowUpResponse>>(
    `${URL}/api/processFollowUp` +
      prepareQueryParams({
        entity: params.entity,
        entityid: params.entityid,
      } as any)
  );
}

export interface GetTaskListByProccodeParams {
  proccode: string;
}

/**
 * @tags Workflow Controller
 * @summary getTaskListByProccode
 */
export function getTaskListByProccode(params: GetTaskListByProccodeParams) {
  return request.get<AbstractResponse<object, ProcTaskListResponse>>(
    `${URL}/api/taskList` +
      prepareQueryParams({ proccode: params.proccode } as any)
  );
}

export interface GetTaskListByTaskTriggerParams {
  tasktrigger: string;
}

/**
 * @tags Workflow Controller
 * @summary getTaskListByTaskTrigger
 */
export function getTaskListByTaskTrigger(
  params: GetTaskListByTaskTriggerParams
) {
  return request.get<AbstractResponse<object, ProcTaskListResponse>>(
    `${URL}/api/taskListBytasktrigger` +
      prepareQueryParams({ tasktrigger: params.tasktrigger } as any)
  );
}

export interface GetListProcTaskByFilterParams {
  entity?: string;
  entityid?: number;
  filteringMode?: string;
  holderid?: number;
  proccode?: string;
  receiverRoleProfile?: string;
  receiverType?: string;
  receiverid?: number;
  senderid?: number;
  taskid?: number;
  taskstatus?: string;
  userid?: number;
}

/**
 * @tags Workflow Controller
 * @summary GetListProcTaskByFilter
 */
export function GetListProcTaskByFilter(params: GetListProcTaskByFilterParams) {
  return request.get<AbstractResponse<object, ViewProcTaskResponse>>(
    `${URL}/api/tasks` +
      prepareQueryParams({
        entity: params.entity,
        entityid: params.entityid,
        filteringMode: params.filteringMode,
        holderid: params.holderid,
        proccode: params.proccode,
        receiverRoleProfile: params.receiverRoleProfile,
        receiverType: params.receiverType,
        receiverid: params.receiverid,
        senderid: params.senderid,
        taskid: params.taskid,
        taskstatus: params.taskstatus,
        userid: params.userid,
      } as any)
  );
}

export interface GetTaskCheckEntityParams {
  entity: string;
  entityid: number;
  taskid: number;
}

/**
 * @tags Workflow Controller
 * @summary getTaskCheckEntity
 */
export function getTaskCheckEntity(params: GetTaskCheckEntityParams) {
  return request.get<AbstractResponse<object, TaskCheckEntityResponse>>(
    `${URL}/api/tasks/checks` +
      prepareQueryParams({
        entity: params.entity,
        entityid: params.entityid,
        taskid: params.taskid,
      } as any)
  );
}

export function initTaskCheckEntity(params: GetTaskCheckEntityParams) {
  return request.get<AbstractResponse<object, TaskCheckEntityResponse>>(
    `${URL}/api/tasks/initChecks` +
      prepareQueryParams({
        entity: params.entity,
        entityid: params.entityid,
        taskid: params.taskid,
      } as any)
  );
}

export interface SaveProcTaskCheckParams {
  req: ProcTaskCheckRequest;
}

/**
 * @tags Workflow Controller
 * @summary saveProcTaskCheck
 */
export function saveProcTaskCheck(params: SaveProcTaskCheckParams) {
  return request.put<AbstractResponse<DataProcTaskCheckResponse, object>>(
    `${URL}/api/tasks/checks`,
    params.req
  );
}

export interface UpdateProcTaskCheckStatusParams {
  checkstatus: string;
  proctaskcheckid: number;
  authid: number;
  cteid: number;
  acceptedvalue: number;
  comment: string;
}

/**
 * @tags Workflow Controller
 * @summary UpdateProcTaskCheckStatus
 */
export function UpdateProcTaskCheckStatus(
  params: UpdateProcTaskCheckStatusParams
) {
  return request.put<AbstractResponse<DataProcTaskCheckResponse, object>>(
    `${URL}/api/tasks/checks/${params.proctaskcheckid}/updateStatus`,
    params
  );
}

export interface GetTaskConseqEntityParams {
  entity: string;
  entityid: number;
  taskid: number;
}

/**
 * @tags Workflow Controller
 * @summary getTaskConseqEntity
 */
export function getTaskConseqEntity(params: GetTaskConseqEntityParams) {
  return request.get<AbstractResponse<object, TaskConseqEntityResponse>>(
    `${URL}/api/tasks/consequences` +
      prepareQueryParams({
        entity: params.entity,
        entityid: params.entityid,
        taskid: params.taskid,
      } as any)
  );
}

export function ExecuteTaskConseqManual(params: ConsequenceExecManualRequest) {
  return request.put<WFengineResponse>(
    `${URL}/api/tasks/consequences/execute` +
      prepareQueryParams({
        entity: params.entity,
        entityid: params.entityid,
        taskid: params.taskid,
        subentity: params.subentity,
        subentityid: params.subentityid,
        conseqid: params.conseqid,
        procid: params.procid,
        proctaskid: params.proctaskid,
        objectreference: params.objectreference,
      } as any)
  );
}

export interface ExecuteTaskConseqParams {
  request: ConsequenceExecRequest;
}

/**
 * @tags Workflow Controller
 * @summary ExecuteTaskConseq
 */
export function ExecuteTaskConseq(params: ExecuteTaskConseqParams) {
  return request.put<WFengineResponse>(
    `${URL}/api/tasks/consequences`,
    params.request
  );
}

export interface UpdateProcTaskConseqStatusParams {
  conseqstatus: string;
  notifid: number;
}

/**
 * @tags Workflow Controller
 * @summary UpdateProcTaskConseqStatus
 */
export function UpdateProcTaskConseqStatus(
  params: UpdateProcTaskConseqStatusParams
) {
  return request.put<AbstractResponse<DataProcTaskConseqResponse, object>>(
    `${URL}/api/tasks/consequences/${params.notifid}/updateStatus/${params.conseqstatus}`
  );
}

export interface GetTaskStepEntityParams {
  entity: string;
  entityid: number;
  taskid: number;
}

/**
 * @tags Workflow Controller
 * @summary getTaskStepEntity
 */
export function getTaskStepEntity(params: GetTaskStepEntityParams) {
  return request.get<AbstractResponse<object, TaskStepEntityResponse>>(
    `${URL}/api/tasks/steps/action` +
      prepareQueryParams({
        entity: params.entity,
        entityid: params.entityid,
        taskid: params.taskid,
      } as any)
  );
}

export interface GetTaskStepWizardParams {
  entity: string;
  entityid?: number;
  taskid?: number;
}

/**
 * @tags Workflow Controller
 * @summary getTaskStepWizard
 */
export function getTaskStepWizard(params: GetTaskStepWizardParams) {
  return request.get<AbstractResponse<object, TaskStepHomeResponse>>(
    `${URL}/api/tasks/steps/wizard` +
      prepareQueryParams({
        entity: params.entity,
        entityid: params.entityid,
        taskid: params.taskid,
      } as any)
  );
}

export interface GetMyWizardsParams {
  entity: string;
}
export interface WizardTasksResponse {
  taskidCreate: number;
  taskidDisplay: number;
  taskidUpdate: number;
}
export function getMyWizards(params: GetMyWizardsParams) {
  return request.get<AbstractResponse<WizardTasksResponse, object>>(
    `${URL}/api/tasks/myWizards` +
      prepareQueryParams({
        entity: params.entity,
      } as any)
  );
}

export interface AssignProcTaskParams {
  proctaskidList: Array<{ proctaskid: number }>;
  userid: number;
}

/**
 * @tags Workflow Controller
 * @summary AssignProcTask
 */
export function AssignProcTask(params: AssignProcTaskParams) {
  return request.put<AbstractResponse<object, object>>(
    `${URL}/api/tasks/assign/${params.userid}`,
    params.proctaskidList
  );
}

export interface AssignProcTaskToMeParams {
  proctaskidList: Array<{ proctaskid: number }>;
}

/**
 * @tags Workflow Controller
 * @summary AssignProcTaskToMe
 */
export function AssignProcTaskToMe(params: AssignProcTaskToMeParams) {
  return request.put<AbstractResponse<object, object>>(
    `${URL}/api/tasks/assignToMe`,
    params.proctaskidList
  );
}

export interface UpdateProcTaskStatusParams {
  proctaskid: number;
  taskstatus: string;
}

/**
 * @tags Workflow Controller
 * @summary UpdateProcTaskStatus
 */
export function UpdateProcTaskStatus(params: UpdateProcTaskStatusParams) {
  return request.put<AbstractResponse<object, object>>(
    `${URL}/api/tasks/${params.proctaskid}/updateStatus/${params.taskstatus}`
  );
}

export interface GetParProcedureByCriteriaParams {
  entity: string;
  proccode: string;
  procstatus: string;
}
export interface GetParProcedureByProccodeParams {
  proccode: string;
}

/**
 * @tags Workflow Controller
 * @summary getParProcedureByCriteria
 */
export function getParProcedureByCriteria(
  params: GetParProcedureByCriteriaParams
) {
  return request.get<AbstractResponse<object, ParProcedureResponse>>(
    `${URL}/api/wfconfig/procedure` +
      prepareQueryParams({
        entity: params.entity,
        proccode: params.proccode,
        procstatus: params.procstatus,
      } as any)
  );
}

export function getParProcedureByProcode(
  params: GetParProcedureByProccodeParams
) {
  return request.get<AbstractResponse<ParProcedureResponse, object>>(
    `${URL}/api/wfconfig/procedure/${params.proccode}`
  );
}

export interface CreateParProcedureParams {
  request: ParProcedureRequest;
}

/**
 * @tags Workflow Controller
 * @summary createParProcedure
 */
export function createParProcedure(params: CreateParProcedureParams) {
  return request.post<AbstractResponse<ParProcedureResponse, object>>(
    `${URL}/api/wfconfig/procedure`,
    params.request
  );
}

export interface UpdateParProcedureParams {
  request: ParProcedureRequest;
}

/**
 * @tags Workflow Controller
 * @summary updateParProcedure
 */
export function updateParProcedure(params: UpdateParProcedureParams) {
  return request.put<AbstractResponse<ParProcedureResponse, object>>(
    `${URL}/api/wfconfig/procedure`,
    params.request
  );
}

export interface GetParProcTaskListParams {
  proccode: string;
}

/**
 * @tags Workflow Controller
 * @summary getParProcTaskList
 */
export function getParProcTaskList(params: GetParProcTaskListParams) {
  return request.get<AbstractResponse<object, ParProcTaskResponse>>(
    `${URL}/api/wfconfig/procedure/${params.proccode}/tasks`
  );
}

export interface GetParProcTaskByTaskidParams {
  taskid: number;
}

export function getParProcTaskByTaskid(params: GetParProcTaskByTaskidParams) {
  return request.get<AbstractResponse<ProcTaskInit, object>>(
    `${URL}/api/wfconfig/tasks/${params.taskid}`
  );
}

export interface UpdateParProcedureStatusParams {
  proccode: string;
  procstatus: string;
}

/**
 * @tags Workflow Controller
 * @summary updateParProcedureStatus
 */
export function updateParProcedureStatus(
  params: UpdateParProcedureStatusParams
) {
  return request.put<AbstractResponse<ParProcedureResponse, object>>(
    `${URL}/api/wfconfig/procedure/${params.proccode}/updateStatus/${params.procstatus}`
  );
}

export interface CreateParProcTaskParams {
  request: ParProcTaskRequest;
}

/**
 * @tags Workflow Controller
 * @summary createParProcTask
 */
export function createParProcTask(params: CreateParProcTaskParams) {
  return request.post<AbstractResponse<ParProcTaskResponse, object>>(
    `${URL}/api/wfconfig/tasks`,
    params.request
  );
}

export interface UpdateParProcTaskParams {
  request: ParProcTaskRequest;
}

/**
 * @tags Workflow Controller
 * @summary updateParProcTask
 */
export function updateParProcTask(params: UpdateParProcTaskParams) {
  return request.put<AbstractResponse<ParProcTaskResponse, object>>(
    `${URL}/api/wfconfig/tasks`,
    params.request
  );
}

export interface GetParProcTaskCheckListParams {
  taskid: number;
}

/**
 * @tags Workflow Controller
 * @summary getParProcTaskCheckList
 */
export function getParProcTaskCheckList(params: GetParProcTaskCheckListParams) {
  return request.get<AbstractResponse<object, ParProcTaskCheckResponse>>(
    `${URL}/api/wfconfig/tasks/${params.taskid}/checks`
  );
}

export interface AddParProcTaskCheckParams {
  request: ParProcTaskCheckRequest;
  taskid?: number;
}

/**
 * @tags Workflow Controller
 * @summary addParProcTaskCheck
 */
export function addParProcTaskCheck(params: AddParProcTaskCheckParams) {
  return request.post<AbstractResponse<ParProcTaskCheckResponse, object>>(
    `${URL}/api/wfconfig/tasks/${params.taskid}/checks`,
    params.request
  );
}

export interface UpdateParProcTaskCheckParams {
  request: ParProcTaskCheckRequest;
  taskid?: number;
}

/**
 * @tags Workflow Controller
 * @summary updateParProcTaskCheck
 */
export function updateParProcTaskCheck(params: UpdateParProcTaskCheckParams) {
  return request.put<AbstractResponse<ParProcTaskCheckResponse, object>>(
    `${URL}/api/wfconfig/tasks/${params.taskid}/checks`,
    params.request
  );
}

export interface RemoveParProcTaskCheckParams {
  checkid: number;
  taskid?: number;
}

/**
 * @tags Workflow Controller
 * @summary removeParProcTaskCheck
 */
export function removeParProcTaskCheck(params: RemoveParProcTaskCheckParams) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/api/wfconfig/tasks/${params.taskid}/checks/${params.checkid}`
  );
}

export interface GetParProcTaskConseqListParams {
  taskid: number;
}

/**
 * @tags Workflow Controller
 * @summary getParProcTaskConseqList
 */
export function getParProcTaskConseqList(
  params: GetParProcTaskConseqListParams
) {
  return request.get<AbstractResponse<object, ParProcTaskConseqResponse>>(
    `${URL}/api/wfconfig/tasks/${params.taskid}/consequences`
  );
}

export interface AddParProcTaskConseqParams {
  request: ParProcTaskConseqRequest;
  taskid?: number;
}

/**
 * @tags Workflow Controller
 * @summary addParProcTaskConseq
 */
export function addParProcTaskConseq(params: AddParProcTaskConseqParams) {
  return request.post<AbstractResponse<ParProcTaskConseqResponse, object>>(
    `${URL}/api/wfconfig/tasks/${params.taskid}/consequences`,
    params.request
  );
}

export interface UpdateParProcTaskConseqParams {
  request: ParProcTaskConseqRequest;
  taskid?: number;
}

/**
 * @tags Workflow Controller
 * @summary updateParProcTaskConseq
 */
export function updateParProcTaskConseq(params: UpdateParProcTaskConseqParams) {
  return request.put<AbstractResponse<ParProcTaskConseqResponse, object>>(
    `${URL}/api/wfconfig/tasks/${params.taskid}/consequences`,
    params.request
  );
}

export interface RemoveParProcTaskConseqParams {
  conseqid: number;
  taskid?: number;
}

/**
 * @tags Workflow Controller
 * @summary removeParProcTaskConseq
 */
export function removeParProcTaskConseq(params: RemoveParProcTaskConseqParams) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/api/wfconfig/tasks/${params.taskid}/consequences/${params.conseqid}`
  );
}

export interface GetParProcTaskStepListParams {
  taskid: number;
}

/**
 * @tags Workflow Controller
 * @summary getParProcTaskStepList
 */
export function getParProcTaskStepList(params: GetParProcTaskStepListParams) {
  return request.get<AbstractResponse<object, ParProcTaskStepResponse>>(
    `${URL}/api/wfconfig/tasks/${params.taskid}/steps`
  );
}

export interface AddParProcTaskStepParams {
  request: ParProcTaskStepRequest;
  taskid?: number;
}

/**
 * @tags Workflow Controller
 * @summary addParProcTaskStep
 */
export function addParProcTaskStep(params: AddParProcTaskStepParams) {
  return request.post<AbstractResponse<ParProcTaskStepResponse, object>>(
    `${URL}/api/wfconfig/tasks/${params.taskid}/steps`,
    params.request
  );
}

export interface UpdateParProcTaskStepParams {
  request: ParProcTaskStepRequest;
  taskid?: number;
}

/**
 * @tags Workflow Controller
 * @summary updateParProcTaskStep
 */
export function updateParProcTaskStep(params: UpdateParProcTaskStepParams) {
  return request.put<AbstractResponse<ParProcTaskStepResponse, object>>(
    `${URL}/api/wfconfig/tasks/${params.taskid}/steps`,
    params.request
  );
}

export interface RemoveParProcTaskStepParams {
  stepid: number;
  taskid?: number;
}

/**
 * @tags Workflow Controller
 * @summary removeParProcTaskStep
 */
export function removeParProcTaskStep(params: RemoveParProcTaskStepParams) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/api/wfconfig/tasks/${params.taskid}/steps/${params.stepid}`
  );
}

export interface UpdateParProcTaskStatusParams {
  taskid: number;
  taskstatus: string;
}

/**
 * @tags Workflow Controller
 * @summary updateParProcTaskStatus
 */
export function updateParProcTaskStatus(params: UpdateParProcTaskStatusParams) {
  return request.put<AbstractResponse<ParProcTaskResponse, object>>(
    `${URL}/api/wfconfig/tasks/${params.taskid}/updateStatus/${params.taskstatus}`
  );
}

export interface ReschedulingParams {
  request: inFinModificationRequest;
}
/**
 * @tags Workflow Controller
 * @summary rescheduling
 */
export function rescheduling(params: ReschedulingParams) {
  return request.post<WFengineResponse>(
    `${URL}/api/Exec/rescheduling`,
    params.request
  );
}

export interface RunEntityFollowUpParams {
  action: string;
  entity: string;
  entityid: number;
  id: number;
  kafkaEnabled?: string;
  requestParam: ExecParametersRequest;
  taskid: number;
}

/**
 * @tags Workflow Controller
 * @summary runEntityFollowUp
 */
export function runEntityFollowUp(params: RunEntityFollowUpParams) {
  return request.post<WFengineResponse>(
    `${URL}/api/Exec/runEntityFollowUp` +
      prepareQueryParams({
        action: params.action,
        entity: params.entity,
        entityid: params.entityid,
        id: params.id,
        kafkaEnabled: params.kafkaEnabled,
        taskid: params.taskid,
      } as any),
    params.requestParam
  );
}

export interface GetEntityFollowUpByCtriteriaParams {
  action: string;
  entity: string;
  entityid: number;
  status: string;
}

/**
 * @tags Workflow Controller
 * @summary getEntityFollowUpByCtriteria
 */
export function getEntityFollowUpByCtriteria(
  params: GetEntityFollowUpByCtriteriaParams
) {
  return request.get<AbstractResponse<object, EntityFollowUpResponse>>(
    `${URL}/api/entityfollowup` +
      prepareQueryParams({
        action: params.action,
        entity: params.entity,
        entityid: params.entityid,
        status: params.status,
      } as any)
  );
}

export interface GetProctaskConseqListByCriteriaParams {
  conseqtype: string;
  objectid: number;
  procmodule: string;
  receivertype: string;
}

/**
 * @tags Workflow Controller
 * @summary getProctaskConseqListByCriteria
 */
export function getProctaskConseqListByCriteria(
  params: GetProctaskConseqListByCriteriaParams
) {
  return request.get<AbstractResponse<object, ProctaskConseqListResponse>>(
    `${URL}/api/workflow/Proctaskconseq` +
      prepareQueryParams({
        conseqtype: params.conseqtype,
        objectid: params.objectid,
        procmodule: params.procmodule,
        receivertype: params.receivertype,
      } as any)
  );
}

export interface GetScheduleTopicNotInvoicedByCriteriaParams {
  ctrid: number;
  ctscategory: string;
  ctstype: string;
  datemax: string;
  datemin: string;
  tpid: number;
  tpname: string;
  tpreference: string;
}

/**
 * @tags Workflow Controller
 * @summary getScheduleTopicNotInvoicedByCriteria
 */
export function getScheduleTopicNotInvoicedByCriteria(
  params: GetScheduleTopicNotInvoicedByCriteriaParams
) {
  return request.get<
    AbstractResponse<object, ScheduleTopicNotInvoicedResponse>
  >(
    `${URL}/api/workflow/scheduleTopicNotInvoiced` +
      prepareQueryParams({
        ctrid: params.ctrid,
        ctscategory: params.ctscategory,
        ctstype: params.ctstype,
        datemax: params.datemax,
        datemin: params.datemin,
        tpid: params.tpid,
        tpname: params.tpname,
        tpreference: params.tpreference,
      } as any)
  );
}

export interface ParCriteriaResponse {
  critcode: string;
  critcolumn: string;
  critfunction: string;
  critid: number;
  critkey: string;
  critlabel: string;
  critmodule: string;
  critmodulelabel: string;
  crittable: string;
  critwhere: string;
  lancode: string;
  returnslist: boolean;
  critdatatype: string;
}
export interface ParRuleResponse {
  critcode: string;
  listvalue: string;
  maxvalue: string;
  minvalue: string;
  rulcode: string;
  rulid: number;
  rullabel: string;
  rulmodule: string;
  ruloperand: string;
}

export interface FindCriteriaListByCriteriaParams {
  critcode: string;
  critlabel: string;
  critmodule: string;
}

/**
 * @tags Rule Engine Controller
 * @summary findCriteriaListByCriteria
 */
export function findCriteriaListByCriteria(
  params: FindCriteriaListByCriteriaParams
) {
  return request.get<AbstractResponse<object, ParCriteriaResponse>>(
    `${URL}/api/criteria` +
      prepareQueryParams({
        critcode: params.critcode,
        critlabel: params.critlabel,
        critmodule: params.critmodule,
      } as any)
  );
}

export interface SaveCriteriaParams {
  request: ParCriteriaResponse;
}

/**
 * @tags Rule Engine Controller
 * @summary saveCriteria
 */
export function saveCriteria(params: SaveCriteriaParams) {
  return request.post<AbstractResponse<ParCriteriaResponse, object>>(
    `${URL}/api/criteria`,
    params.request
  );
}

export interface GetCriteriaByIdParams {
  critid: number;
}

/**
 * @tags Rule Engine Controller
 * @summary getCriteriaById
 */
export function getCriteriaById(params: GetCriteriaByIdParams) {
  return request.get<AbstractResponse<ParCriteriaResponse, object>>(
    `${URL}/api/criteria/${params.critid}`
  );
}

export interface UpdateCriteriaParams {
  critid: number;
  updateRequest: ParCriteriaResponse;
}

/**
 * @tags Rule Engine Controller
 * @summary updateCriteria
 */
export function updateCriteria(params: UpdateCriteriaParams) {
  return request.put<AbstractResponse<ParCriteriaResponse, object>>(
    `${URL}/api/criteria/${params.critid}`,
    params.updateRequest
  );
}

export interface DeleteCriteriaParams {
  critid: number;
}

/**
 * @tags Rule Engine Controller
 * @summary deleteCriteria
 */
export function deleteCriteria(params: DeleteCriteriaParams) {
  return request.delete<AbstractResponse<ParCriteriaResponse, object>>(
    `${URL}/api/criteria/${params.critid}`
  );
}
export interface FindRuleParams {
  critcode: string;
  rulcode: string;
  rullabel: string;
  rulmodule: string;
}

/**
 * @tags Rule Engine Controller
 * @summary findRule
 */
export function findRule(params: FindRuleParams) {
  return request.get<AbstractResponse<object, ParRuleResponse>>(
    `${URL}/api/rule` +
      prepareQueryParams({
        critcode: params.critcode,
        rulcode: params.rulcode,
        rullabel: params.rullabel,
        rulmodule: params.rulmodule,
      } as any)
  );
}

export interface SaveRuleParams {
  request: ParRuleResponse;
}

/**
 * @tags Rule Engine Controller
 * @summary saveRule
 */
export function saveRule(params: SaveRuleParams) {
  return request.post<AbstractResponse<ParRuleResponse, object>>(
    `${URL}/api/rule`,
    params.request
  );
}

export interface FindRuleByCodeParams {
  rulcode: string;
}

/**
 * @tags Rule Engine Controller
 * @summary findRuleByCode
 */
export function findRuleByCode(params: FindRuleByCodeParams) {
  return request.get<AbstractResponse<ParRuleResponse, object>>(
    `${URL}/api/rule/${params.rulcode}`
  );
}

export interface UpdateRuleParams {
  request: ParRuleResponse;
  rulcode: string;
}

/**
 * @tags Rule Engine Controller
 * @summary UpdateRule
 */
export function UpdateRule(params: UpdateRuleParams) {
  return request.put<AbstractResponse<ParRuleResponse, object>>(
    `${URL}/api/rule/${params.rulcode}`,
    params.request
  );
}

export interface DeleteRuleParams {
  rulcode: string;
}

/**
 * @tags Rule Engine Controller
 * @summary deleteRule
 */
export function deleteRule(params: DeleteRuleParams) {
  return request.delete<AbstractResponse<ParRuleResponse, object>>(
    `${URL}/api/rule/${params.rulcode}`
  );
}

export interface checkApplicationRuleRequest {
  applicationRule: string;
  entity: string;
  entityid: number;
  userid: number;
}

export interface checkCriteriaRequest {
  critcolumn: string;
  critfunction: string;
  critkey: string;
  critmodule: string;
  crittable: string;
  critwhere: string;
  entity: string;
  entityid: number;
  returnslist: boolean;
  userid: number;
}
export interface checkRuleRequest {
  critcode: string;
  entity: string;
  entityid: number;
  listvalue: string;
  maxvalue: string;
  minvalue: string;
  rulcode: string;
  rulid: number;
  rullabel: string;
  rulmodule: string;
  ruloperand: string;
  userid: number;
}

export interface CheckruleParams {
  checkRequest: checkRuleRequest;
}

/**
 * @tags Rule Engine Controller
 * @summary checkrule
 */
export function checkrule(params: CheckruleParams) {
  return request.post<AbstractResponse<boolean, object>>(
    `${URL}/api/rule/check/new`,
    params.checkRequest
  );
}

export interface CheckCriteriaParams {
  checkRequest: checkCriteriaRequest;
}

/**
 * @tags Rule Engine Controller
 * @summary checkCriteria
 */
export function checkCriteria(params: CheckCriteriaParams) {
  return request.post<AbstractResponse<string, object>>(
    `${URL}/api/criteria/check/new`,
    params.checkRequest
  );
}
export interface CheckApplicationRuleParams {
  checkRequest: checkApplicationRuleRequest;
}

/**
 * @tags Rule Engine Controller
 * @summary checkApplicationRule
 */
export function checkApplicationRule(params: CheckApplicationRuleParams) {
  return request.post<AbstractResponse<string, object>>(
    `${URL}/api/applicationrule/check/new`,
    params.checkRequest
  );
}
export interface MgUsersFavoriteRequest {
  mgid: number;
  taskid: number;
}

export interface MgUsersFavoriteResponse {
  favoriteid: number;
  id: number;
  mgid: number;
  mgname: string;
  taskid: number;
  tasklabel: string;
}
export function getMyFavorite() {
  return request.get<AbstractResponse<object, MgUsersFavoriteResponse>>(
    `${URL}/api/users/myFavorite`
  );
}

export interface AddFavoriteParams {
  request: MgUsersFavoriteRequest;
}

/**
 * @tags Users Controller
 * @summary addFavorite
 */
export function addFavorite(params: AddFavoriteParams) {
  return request.post<AbstractResponse<object, MgUsersFavoriteResponse>>(
    `${URL}/api/users/myFavorite`,
    params.request
  );
}

export interface RemoveFavoriteParams {
  favoriteid: number;
}

/**
 * @tags Users Controller
 * @summary removeFavorite
 */
export function removeFavorite(params: RemoveFavoriteParams) {
  return request.delete<AbstractResponse<object, MgUsersFavoriteResponse>>(
    `${URL}/api/users/myFavorite/${params.favoriteid}`
  );
}

export interface FinModRestoreParams {
  kafkaEnabled?: string;
  req: FinModRestoreRequestWf;
}

/**
 * @tags Workflow Controller
 * @summary finModRestore
 */
export function finModRestore(params: FinModRestoreParams) {
  return request.post<WFengineResponse>(
    `${URL}/api/Exec/finModRestore` +
      prepareQueryParams({ kafkaEnabled: params.kafkaEnabled } as any),
    params.req
  );
}

export interface GetParProcTaskMgParams {
  taskid: number;
}

/**
 * @tags Workflow Controller
 * @summary getParProcTaskMg
 */
export function getParProcTaskMg(params: GetParProcTaskMgParams) {
  return request.get<AbstractResponse<object, ParProcTaskMgResponse>>(
    `${URL}/api/parproctaskmg` +
      prepareQueryParams({ taskid: params.taskid } as any)
  );
}

export interface CreateParProcTaskMgParams {
  request: ParProcTaskMgRequest;
}

/**
 * @tags Workflow Controller
 * @summary createParProcTaskMg
 */
export function createParProcTaskMg(params: CreateParProcTaskMgParams) {
  return request.post<AbstractResponse<ParProcTaskMgResponse, object>>(
    `${URL}/api/parproctaskmg`,
    params.request
  );
}

export interface RemoveParProcTaskMgParams {
  id: number;
}

/**
 * @tags Workflow Controller
 * @summary removeParProcTaskMg
 */
export function removeParProcTaskMg(params: RemoveParProcTaskMgParams) {
  return request.delete<AbstractResponse<ParProcTaskMgResponse, object>>(
    `${URL}/api/parproctaskmg/${params.id}`
  );
}

export interface GetParProcTaskProductParams {
  taskid: number;
}

/**
 * @tags Workflow Controller
 * @summary getParProcTaskProduct
 */
export function getParProcTaskProduct(params: GetParProcTaskProductParams) {
  return request.get<AbstractResponse<object, ParProcTaskProductResponse>>(
    `${URL}/api/proctaskproduct` +
      prepareQueryParams({ taskid: params.taskid } as any)
  );
}

export interface CreateParProcTaskProductParams {
  request: ParProcTaskProductRequest;
}

/**
 * @tags Workflow Controller
 * @summary createParProcTaskProduct
 */
export function createParProcTaskProduct(
  params: CreateParProcTaskProductParams
) {
  return request.post<AbstractResponse<ParProcTaskProductResponse, object>>(
    `${URL}/api/parproctaskproduct`,
    params.request
  );
}

export interface RemoveParProcTaskProductParams {
  id: number;
}

/**
 * @tags Workflow Controller
 * @summary removeParProcTaskProduct
 */
export function removeParProcTaskProduct(
  params: RemoveParProcTaskProductParams
) {
  return request.delete<AbstractResponse<ParProcTaskProductResponse, object>>(
    `${URL}/api/parproctaskproduct/${params.id}`
  );
}


export interface TpAuthorizationUseParams {
  kafkaEnabled?: string;
  request: InTpAuthorizationUseRequest;
}


/**
 * @tags Workflow Controller
 * @summary tpAuthorizationUse
 */
export function tpAuthorizationUse (params: TpAuthorizationUseParams) {
  return request.post<WFengineResponse>(`${URL}/api/Exec/TpAuthorizationUse` + prepareQueryParams({kafkaEnabled: params.kafkaEnabled} as any), params.request)
}
